import { useMutation } from '@tanstack/react-query'
import axios from 'axios'

export const AdminTasksEndpoints = {
  unassignTask: '/tasks/unassign',
}

export const useUnassignTask = () => {
  return useMutation({
    mutationFn: async () => {
      const response = await axios.post(AdminTasksEndpoints.unassignTask)
      return response.data
    },
  })
}
